<div class="w-full" id="pop-hotels">
    <div class="hidden md:block relative">
        <ng-container *ngIf="resetSwiper()">
            <swiper [config]="configSwiper" class="popular-destination-swiper">
                <ng-template class="swiper-slide-destination" swiperSlide *ngFor="let itemHotel of data; let i = index">
                    <div >
                        <a (click)="scrollToCity(itemHotel, i, $event)" class="destination-card-desktop items-start cursor-pointer">
                                <img id="itemHotel.ID" [ngSrc]="itemHotel.PictureUrl"
                                    (error)="itemHotel.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                                [alt]="itemHotel.PictureName" height="137" width="171"
                                class="h-[137px] w-[171px] img-city rounded-lg object-cover">
                            <h2 class="text-[13px] font-medium mt-2 text-[#5D6067] text-right w-full">{{itemHotel.Title}}</h2>
                            </a>

                    </div>
                </ng-template>
            </swiper>
        </ng-container>
        <div *ngIf="data?.length > 6" class="swiper-button-prev-popular swiper-button-prev">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
        </div>
    </div>

    
    <div #mobileContainer class="md:hidden mobile-container" [class.sticky-container]="isSticky()">
        
        <div *ngIf="!isSticky()" class="mobile-grid-container relative">
            <div class="grid grid-cols-4 gap-3" [class.collapsed]="!isExpanded()">
                <ng-container *ngFor="let itemHotel of data; let i = index">
                    <a *ngIf="i < 4" (click)="scrollToCity(itemHotel, i, $event)" 
                        class="destination-card-mobile flex flex-col items-center cursor-pointer">
                        <img [ngSrc]="itemHotel.PictureUrl"
                            (error)="itemHotel.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                            [alt]="itemHotel.PictureName" height="64" width="64"
                            class="h-[64px] w-[64px] rounded-lg object-cover">
                        <h2 class="text-[13px] font-medium mt-1 text-center line-clamp-1">{{itemHotel.Title}}</h2>
                    </a>
                    
                    <ng-container *ngIf="i >= 4">
                        <a *ngIf="isExpanded()" (click)="scrollToCity(itemHotel, i, $event)" 
                            class="destination-card-mobile flex flex-col items-center cursor-pointer">
                            <img [ngSrc]="itemHotel.PictureUrl"
                                (error)="itemHotel.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                                [alt]="itemHotel.PictureName" height="64" width="64"
                                class="h-[64px] w-[64px] rounded-lg object-cover">
                            <h2 class="text-[13px] font-medium mt-1 text-center line-clamp-1">{{itemHotel.Title}}</h2>
                        </a>
                        
                        <div *ngIf="!isExpanded()" 
                            class="destination-card-mobile flex flex-col items-center faded-item"
                            [class.second-row]="i >= 4 && i < 8"
                            [class.third-row]="i >= 8">
                            <img [ngSrc]="itemHotel.PictureUrl"
                                (error)="itemHotel.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                                [alt]="itemHotel.PictureName" height="64" width="64"
                                class="h-[64px] w-[64px] rounded-lg object-cover">
                            <h2 class="text-[13px] font-medium mt-1 text-center line-clamp-1">{{itemHotel.Title}}</h2>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            
            <div *ngIf="!isExpanded() && data?.length > 4" class="fade-overlay"></div>
            
            <button *ngIf="data?.length > 4" 
                (click)="toggleExpand()" 
                class="expand-btn">
                <svg xmlns="http://www.w3.org/2000/svg" 
                    [class.rotate-180]="isExpanded()"
                    class="w-6 h-6 transition-transform duration-300" 
                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
        </div>
        
        <div *ngIf="isSticky()" class="sticky-swiper-container">
            <ng-container *ngIf="resetSwiper()">
                <swiper [config]="configSwiperMobile">
                    <ng-template swiperSlide *ngFor="let itemHotel of data; let i = index">
                        <a (click)="scrollToCity(itemHotel, i, $event)" class="sticky-slide cursor-pointer">
                            <img [ngSrc]="itemHotel.PictureUrl"
                                (error)="itemHotel.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                                [alt]="itemHotel.PictureName" height="64" width="64"
                                class="h-[64px] w-[64px] rounded-lg object-cover">
                            <h2 class="text-[10px] font-medium mt-1 text-center line-clamp-1">{{itemHotel.Title}}</h2>
                        </a>
                    </ng-template>
                </swiper>
            </ng-container>
        </div>
    </div>
</div>
